"use client";

import React from "react";
import { Breadcrumbs, BreadcrumbItem } from "@nextui-org/breadcrumbs";
import Link from "next/link";

interface BreadcrumbsProps {
  items: {
    label: string;
    href: string;
  }[];
}

const ClientBreadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  const [windowWidth, setWindowWidth] = React.useState<number>(
    typeof window !== "undefined" ? window.innerWidth : 0,
  );

  React.useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 640; // スマホサイズの閾値を640pxとします

  const visibleItems = isMobile ? items.slice(-2) : items;

  return (
    <div className="max-w-full overflow-x-auto">
      <Breadcrumbs className="max-w-full">
        {isMobile && items.length > 2 && <BreadcrumbItem>...</BreadcrumbItem>}
        {visibleItems.map((item, index) => (
          <BreadcrumbItem key={index}>
            <Link
              href={item.href}
              className="truncate max-w-[300px] md:max-w-full inline-block"
            >
              {item.label}
            </Link>
          </BreadcrumbItem>
        ))}
      </Breadcrumbs>
    </div>
  );
};

export default ClientBreadcrumbs;
